// Module
var code = "<h2 id=\"monthly-bill\">Monthly Bill</h2> <p>Learn about your monthly bill and all that comes with it. </p> ";
// Exports
export default code;